import {
  Box,
  Button,
  Card,
  Container,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { useState } from "react";
import CustomTextField from "./ui/CustomTextField";
import useFetch from "../hooks/useFetch";
import GapGrid from "./GapGrid";

export default function StockSettings({ row, refresh }) {
  const fetchData = useFetch();

  const [data, setData] = useState(row);
  const [errors, setErrors] = useState({});
  const [editable, setEditable] = useState(false);

  const fields = [
    {
      label: "Productie tijd",
      name: "leadTime",
      type: "number",
      endAdornment: "dagen",
    },
    {
      label: "Zendingsduur",
      name: "shippingTime",
      type: "number",
      endAdornment: "dagen",
    },
    {
      label: "Veiligheidsmarge",
      name: "safetyStock",
      type: "number",
      endAdornment: "%",
      decimals: 1,
    },
    {
      label: "Stuks in doos",
      name: "unitsPerCarton",
      type: "number",
    },
    {
      label: "MOQ",
      name: "moq",
      type: "number",
    },
    {
      label: "Positie in lijst",
      name: "order",
      type: "number",
    },
    {
      label: "Aanvul notificatie",
      name: "replenishNotification",
      type: "switch",
    },
    {
      label: "Bestel notificatie",
      name: "reorderNotification",
      type: "switch",
    },
  ];

  async function handleEdit() {
    if (editable) {
      const payload = fields.reduce(
        (acc, field) => {
          const value = data[field.name];
          if (field.type === "number") {
            acc[field.name] = value === "" ? null : Number(value);
          } else {
            acc[field.name] = value;
          }
          return acc;
        },
        { ean: row.ean },
      );
      await fetchData(
        `/api/crud/stockSettings/put?ean=${row.ean}`,
        "POST",
        payload,
      );
      await refresh();
    }
    setEditable(!editable);
  }
  if (!row) return;
  return (
    <Container size={"lg"} sx={{ my: 3 }}>
      <Grid container rowSpacing={2}>
        <Grid size={12}>
          <Box>
            <Typography variant={"h4"} sx={{ fontWeight: 900 }}>
              {row.referenceCode}
            </Typography>
            <Typography variant={"subtitle"}>{row.ean}</Typography>
            <Divider />
          </Box>
        </Grid>
        <Grid size={3}>
          <Card variant="outlined" sx={{ p: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "end", mb: 1 }}>
              <Button variant={"contained"} onClick={handleEdit}>
                {editable ? "Opslaan" : "Bewerken"}
              </Button>
            </Box>
            <Grid>
              {fields.map((field, index) => (
                <Grid size={{ xs: 12, sm: field.col }} key={index}>
                  <CustomTextField
                    field={field}
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    editable={editable}
                  />
                </Grid>
              ))}
            </Grid>
          </Card>
        </Grid>
        <Grid size={12}>
          <GapGrid row={row} />
        </Grid>
      </Grid>
    </Container>
  );
}
